import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { AppDataSharingService, AppConfigService, DataStorageService, Constants } from '@pulse/common'
@Injectable({ providedIn: 'root' })
export class OktaAuthService {


  // If using a custom authorization server, ISSUER should be 'https://${yourOktaDomain}/oauth2/${authorizationServerId}'

  LOGOUT_REDIRECT_URI = '';
  oktaAuth;



  constructor(private router: Router,
    private appDataSharingService: AppDataSharingService,
    private configService: AppConfigService,
    private dataStorageService: DataStorageService) {

    this.appDataSharingService.logout.subscribe((flag) => {
      if (flag) {
        this.logout()
      }
    })
  }

  login(originalUrl: string) {
    sessionStorage.setItem('okta-app-url', originalUrl || this.router.url);

    // Launches the login redirect.
    this.oktaAuth.token.getWithRedirect({
      scopes: ['openid', 'profile', 'email'],
      responseType: ['code'],
    });
  }

  isAuthenticatedOkta(resolve) {
    // Save current URL before redirect
    const url = window.location.pathname + window.location.search;
    if (url && url !== '/' && !url.startsWith('/marketing') && !url.startsWith('/?code')) {
      this.appDataSharingService.setRedirectUrl(url);
      this.dataStorageService.writeToSessionStorage('postLoginURL', url);
    }

    this.oktaAuth = new OktaAuth(this.configService.get('oktaConfig'));
    let search = window.location.search;
    if (search) {
      search = search.substr(1);
      const queryParams = this.getObjFromQuesry(search);
      if (
        queryParams &&
        queryParams.code &&
        queryParams.state
      ) {
        this.dataStorageService.writeToLocalStorage(
          'JWTCode',
          queryParams.code
        );
        this.dataStorageService.removeToLocalStorage(Constants.SESSION_KEY);
        this.dataStorageService.removeToLocalStorage(
          Constants.SESSION_EXPIRE
        );
        resolve();

      } else if (
        queryParams &&
        queryParams.sessionId &&
        queryParams.sessionExpire
      ) {
        this.dataStorageService.writeToLocalStorage(
          Constants.SESSION_KEY,
          queryParams.sessionId
        );
        this.dataStorageService.writeToLocalStorage(
          Constants.SESSION_EXPIRE,
          queryParams.sessionExpire
        );
        this.validateSessionId(resolve);
      } else {
        this.validateSessionId(resolve)
      }
    } else {
      this.validateSessionId(resolve)
    }


  }

  getObjFromQuesry(search) {
    var params = search.split('&');
    var queryParams: any = {};
    params.forEach((param) => {
      var keyVal = param.split('=');
      queryParams[keyVal[0]] = keyVal[1];
    });
    return queryParams;
  }


  validateSessionId(resolve) {
    const sessionId = this.dataStorageService.readFromLocalStorage(
      Constants.SESSION_KEY
    );
    const sesssionExpire = this.dataStorageService.readFromLocalStorage(
      Constants.SESSION_EXPIRE
    );
    if (
      sessionId &&
      sesssionExpire &&
      new Date() < new Date(parseInt(sesssionExpire, 10))
    ) {
      resolve();
    } else {
      resolve();

      if (sessionStorage.getItem('userLoggedIn') || sessionStorage.getItem('userLoggedOut')) {
        sessionStorage.removeItem('userLoggedIn');
        this.initiateLogin();
      } else {
        this.router.navigate(['/marketing']);
      }
      //this.login(window.location.href);
    }
  }

  isLoginRedirect() {
    return this.oktaAuth.isLoginRedirect();
  }

  initiateLogin() {
    this.login(window.location.href);
  }

  async logout() {
    this.dataStorageService.removeToLocalStorage(Constants.SESSION_KEY);
    this.dataStorageService.removeToLocalStorage(Constants.SESSION_EXPIRE);
    this.dataStorageService.removeToLocalStorage('JWTCode');
    localStorage.removeItem('VALID_USER_SESSION');
    sessionStorage.setItem('userLoggedOut', 'true');

    await this.oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin
    });

  }
}